import React from 'react';
import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { breadcrumbStyles } from './Breadcrumb.styles';

const Breadcrumb = ({ items = [], current }) => {
  const navigate = useNavigate();

  const handleNavigate = path => {
    if (path) {
      navigate(path);
    }
  };

  if (!items.length && !current) {
    return null;
  }

  return (
    <Box sx={breadcrumbStyles.container}>
      {items.map((item, index) => (
        <Box key={index} sx={breadcrumbStyles.item}>
          <Typography
            sx={breadcrumbStyles.link}
            onClick={() => handleNavigate(item.path)}
          >
            {item.label}
          </Typography>
          {(index < items.length - 1 || current) && (
            <Typography sx={breadcrumbStyles.separator}>→</Typography>
          )}
        </Box>
      ))}
      {current && (
        <Typography sx={breadcrumbStyles.current}>{current}</Typography>
      )}
    </Box>
  );
};

export default Breadcrumb;
